import { defineMessages } from "react-intl";
export var messages = defineMessages({
  invalidPhone: {
    id: "jutro-components.widgets.inputs.PhoneNumberField.invalid",
    defaultMessage: "The provided phone number is not valid"
  }
});